import { Injectable, OnDestroy } from '@angular/core';

const CHANNEL_NAME = 'gr-tab-sync';

const MSG = {
  REQUEST_MASTER: 'REQUEST_MASTER',
  MASTER_HERE: 'MASTER_HERE',
  MASTER_CLOSING: 'MASTER_CLOSING',
  SLAVE_FLUSH: 'SLAVE_FLUSH',
} as const;

@Injectable({ providedIn: 'root' })
export class TabCoordinatorService implements OnDestroy {
  private channel = new BroadcastChannel(CHANNEL_NAME);
  private _isMaster = false;
  private electionTimeout: any;

  /** Called by ScreenTimeTrackerService when master receives time from a slave */
  onSlaveTime?: (seconds: number) => void;

  get isMaster(): boolean {
    return this._isMaster;
  }

  init(): void {
    this.channel.onmessage = ({ data }) => this.handleMessage(data);

    // Ask if there is already a master
    this.channel.postMessage({ type: MSG.REQUEST_MASTER });

    // If nobody responds in 300ms, this tab becomes master
    this.electionTimeout = setTimeout(() => this.becomeMaster(), 300);

    window.addEventListener('beforeunload', () => this.onBeforeUnload());
  }

  /** Slave tabs call this to report their accumulated seconds to the master */
  reportToMaster(seconds: number): void {
    this.channel.postMessage({ type: MSG.SLAVE_FLUSH, seconds });
  }

  private handleMessage(data: any): void {
    switch (data.type) {
      case MSG.REQUEST_MASTER:
        if (this._isMaster) {
          this.channel.postMessage({ type: MSG.MASTER_HERE });
        }
        break;

      case MSG.MASTER_HERE:
        // Another tab is already master — cancel our election
        clearTimeout(this.electionTimeout);
        this._isMaster = false;
        break;

      case MSG.MASTER_CLOSING:
        // Master is gone — take over
        this.becomeMaster();
        break;

      case MSG.SLAVE_FLUSH:
        if (this._isMaster && this.onSlaveTime) {
          this.onSlaveTime(data.seconds);
        }
        break;
    }
  }

  private becomeMaster(): void {
    this._isMaster = true;
  }

  private onBeforeUnload(): void {
    if (this._isMaster) {
      this.channel.postMessage({ type: MSG.MASTER_CLOSING });
    }
  }

  ngOnDestroy(): void {
    this.channel.close();
  }
}
